import { tr } from 'mmfintech-commons'

const ACCOUNTING_CATEGORIES = [
  { value: 'REPAIRS_MAINTENANCE', fallback: 'Repairs & Maintenance' },
  { value: 'WAGES_SALARIES', fallback: 'Wages & Salaries' },
  { value: 'SOFTWARE_SUBSCRIPTIONS', fallback: 'Software & Subscriptions' },
  { value: 'COGS', fallback: 'Cost of Goods Sold' },
  { value: 'MARKETING_ADVERTISING', fallback: 'Advertising & Marketing' },
  { value: 'LEGAL_PROFESSIONAL', fallback: 'Legal & Professional' },
  { value: 'OFFICE_EXPENSES', fallback: 'Office Expenses' },
  { value: 'RENT_LEASE', fallback: 'Rent & Lease' },
  { value: 'TAX', fallback: 'Tax & VAT' },
  { value: 'TRAVEL_SUBSISTENCE', fallback: 'Travel & Subsistence' },
  { value: 'UTILITIES', fallback: 'Utilities' },
  { value: 'BANK_CHARGES', fallback: 'Bank Charges & Fees' },
  { value: 'INCOME_REFUNDS', fallback: 'Income & Refunds' },
  { value: 'OTHER', fallback: 'Other / Miscellaneous' },
  { value: 'UNCATEGORIZED', fallback: 'Uncategorized' }
] as const

export const getAccountingCategoryLabel = (value: string): string => {
  const entry = ACCOUNTING_CATEGORIES.find(c => c.value === value)
  return entry ? tr(`FRONTEND.ACCOUNTING_CATEGORY.${entry.value}`, entry.fallback) : value
}

export const getAccountingCategoryOptions = () =>
  ACCOUNTING_CATEGORIES.map(({ value, fallback }) => ({
    value,
    label: tr(`FRONTEND.ACCOUNTING_CATEGORY.${value}`, fallback)
  }))

export const getAccountingCategoryPaymentOptions = () =>
  getAccountingCategoryOptions().filter(o => o.value !== 'UNCATEGORIZED')
